import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

// Measured off the Arches "Current Cases" status cell: 77px outer diameter with
// a 9.4px stroke. strokeWidth is in the 100-unit viewBox, so it tracks size.
const RING_SIZE = 77;
const RING_STROKE_WIDTH = 12;

const XCircularProgress = ({
    value = 0,
    isFailed = false,
    size = RING_SIZE,
    strokeWidth = RING_STROKE_WIDTH,
    fontSize = '20px',
    className = ''
}) => {
    // Clamp value between 0 and 100
    const clampedValue = Math.max(0, Math.min(100, value));

    // Arches draws the status ring flat: Sand normally, danger when the run failed.
    const pathStroke = isFailed ? 'var(--color-danger)' : 'var(--color-accent)';

    return (
        <div className={className} style={{ width: `${size}px`, height: `${size}px` }}>
            <CircularProgressbar
                value={Number(clampedValue)}
                text={`${clampedValue}%`}
                strokeWidth={strokeWidth}
                styles={{
                    path: { stroke: pathStroke },
                    trail: { stroke: "var(--color-accent-surface)" },
                    text: { fill: "var(--color-content)", fontSize, fontWeight: "600" },
                    background: { fill: "var(--color-surface)" }
                }}
            />
        </div>
    );
};

export default XCircularProgress;
